export const AUTH_USER_DATA_REQUEST = "AUTH_USER_DATA_REQUEST";
export const AUTH_USER_DATA_SUCCESS = "AUTH_USER_DATA_SUCCESS";
export const AUTH_USER_DATA_FAIL = "AUTH_USER_DATA_FAIL";
export const AUTH_USER_DATA_RESET = "AUTH_USER_DATA_RESET";
